/** Google Fonts CSS for Inter (SafeCharge iframe fields need a concrete URL). */
export const INTER_FONT_CSS_URL =
  'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap';

/** Prefer CSS tokens in app UI: var(--font-body) / var(--font-heading). */
export const FONT_BODY = 'var(--font-body)';
export const FONT_HEADING = 'var(--font-heading)';

/** Concrete family names for third-party embeds that cannot resolve CSS variables. */
export const INTER_FONT_FAMILY = 'Inter, sans-serif';
export const MANROPE_FONT_FAMILY = 'Manrope, sans-serif';

export const SAFECHARGE_FIELDS_OPTIONS = {
  fonts: [{ cssUrl: INTER_FONT_CSS_URL }],
  locale: 'en',
  fontSize: '16px',
};

export const SAFECHARGE_FIELD_BASE_STYLE = {
  fontFamily: INTER_FONT_FAMILY,
  fontSize: '16px',
  color: '#0E0E0B',
} as const;
